import { ContractTypeOption } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum ContractTypeActions {
  Reset = '[Filter] Reset Contract Type Filter',
  Set = '[Filter] Set Contract Type Filter',
  SetBasedOnValues = '[Filter] Set Contract Type Filter Based On Values',
}

export const resetContractTypeFilter = createAction(ContractTypeActions.Reset);

export const setContractTypeFilter = createAction(
  ContractTypeActions.Set,
  props<{ filter: ContractTypeOption }>()
);

export const setContractTypeFilterBasedOnUrlValue = createAction(
  ContractTypeActions.SetBasedOnValues,
  props<{ value: string }>()
);
